function ProductVisual(props:any) {
    //console.log(props);
    //console.log("this is a brand, ",props.brand);
  return (
    <div className="product-visual">
        <h2 >Digital product passport 
            <div className="tooltip">
                <img className="svg-info" src="../../img/i-icon.svg"></img>
                <span className="tooltiptext" style={{width:"200px"}}>A digital product passport provides detailed information about the product, such as its features, materials used, and environmental impact. The purpose of a digital product passport is to enable transparency and traceability throughout a product's lifecycle. It can help you make informed decisions about the products you purchase.</span>
            </div>
        </h2>
        <h3 className="product-title">{props.parentProduct?.title}</h3>
    </div>
  );
}
export default ProductVisual;
